(function () {
  'use strict';

  /* ── Name char counter + strip invalid characters ── */
  document.querySelectorAll('.metafield-name-input').forEach(function (input) {
    var max = parseInt(input.dataset.max, 10) || 15;
    var counter = document.getElementById(input.dataset.counter);

    if (counter) {
      counter.textContent = '0/' + max;
    }

    input.addEventListener('input', function () {
      var val = input.value.replace(/[^A-Za-z\s.,'!\-]/g, '');

      if (val.length > max) {
        val = val.substring(0, max);
      }

      input.value = val;

      var len = val.trim().length;

      if (counter) {
        counter.textContent = len + '/' + max;
        counter.style.color = len === max ? 'red' : '#666';
      }
    });
  });

  /* ── Name count dropdown: show/hide fields ── */
  document
    .querySelectorAll('.personalisation-count-select')
    .forEach(function (select) {
      applyCountSelection(select);

      select.addEventListener('change', function () {
        applyCountSelection(this);
      });
    });

  function applyCountSelection(select) {
    var count = parseInt(select.value, 10);
    var group = select.dataset.group;

    document
      .querySelectorAll(
        '[data-group="' + group + '"][data-field-index]'
      )
      .forEach(function (fieldWrapper) {
        var index = parseInt(fieldWrapper.dataset.fieldIndex, 10);
        var isVisible = index <= count;

        fieldWrapper.classList.toggle('is-hidden', !isVisible);

        fieldWrapper
          .querySelectorAll('input, select')
          .forEach(function (field) {
            field.disabled = !isVisible;

            if (!isVisible) {
              field.value = '';

              if (field.dataset.counter) {
                var counter = document.getElementById(
                  field.dataset.counter
                );

                if (counter) {
                  counter.textContent =
                    '0/' +
                    (parseInt(field.dataset.max, 10) || 15);
                  counter.style.color = '#666';
                }
              }
            }
          });
      });
  }

  /* ── Charm pill picker: show/hide letter dropdowns ── */
  document
    .querySelectorAll('.personalisation-charms .charm-count-pills')
    .forEach(function (pillsEl) {
      pillsEl.querySelectorAll('.charm-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var count = parseInt(pill.dataset.value, 10);

          pillsEl.querySelectorAll('.charm-pill').forEach(function (p) {
            p.classList.toggle('charm-pill--active', p === pill);
          });

          document
            .querySelectorAll(
              '[data-group="charm-fields"][data-field-index]'
            )
            .forEach(function (fieldWrapper) {
              var index = parseInt(
                fieldWrapper.dataset.fieldIndex,
                10
              );
              var isVisible = index <= count;

              fieldWrapper.classList.toggle(
                'is-hidden',
                !isVisible
              );

              fieldWrapper
                .querySelectorAll('select')
                .forEach(function (sel) {
                  sel.disabled = !isVisible;

                  if (!isVisible) {
                    sel.value = '';
                  }
                });
            });
        });
      });
    });

  /* ── Re-init on theme editor reload ── */
  document.addEventListener('shopify:section:load', function () {
    document
      .querySelectorAll('.personalisation-count-select')
      .forEach(function (select) {
        applyCountSelection(select);
      });
  });
})();